// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__356Oo","notes":"Notes_notes__q9TPv"};